import React, { FC, ReactNode } from "react";
import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import { useStyles } from "./SuccessBannerStyles";

const SuccessBannerC: FC<{ children: ReactNode }> = ({ children }) => {
  const styles = useStyles();
  const { bodytextDefaultNone } = useTheme();
  return (
    <div
      className={styles.success}
      style={{ fontFamily: bodytextDefaultNone?.fontFamily || "inherit" }}>
      {children}
    </div>
  );
};

export default withThemeProvider(SuccessBannerC, {
  themeTokens: ["bodytextDefaultNone"],
});
